import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { newInvoiceRouteRef, rootRouteRef } from './routes';

export const invoicingPlugin = createPlugin({
  id: 'invoicing',
  routes: {
    root: rootRouteRef,
    new: newInvoiceRouteRef
  },
});

export const InvoicingPage = invoicingPlugin.provide(
  createRoutableExtension({
    name: 'InvoicingPage',
    component: () =>
      import('./components/InvoicingComponent').then(m => m.InvoicingComponent),
    mountPoint: rootRouteRef,
  }),
);

export const NewInvoicePage = invoicingPlugin.provide(
  createRoutableExtension({
    name: 'NewInvoicePage',
    component: () =>
      import('./components/NewInvoice').then(m => m.NewInvoicePage),
    mountPoint: newInvoiceRouteRef,
  }),
);